"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FeeDetailController = /** @class */ (function () {
    function FeeDetailController(UsersModel, FlashService) {
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.submitted = false;
    }
    FeeDetailController.prototype.formatPaymentAmount = function (amount) {
        var a = parseInt(amount, 10) / 100;
        return a.toFixed(2).toString();
    };
    FeeDetailController.prototype.voidPayment = function (payment_id, index) {
        var _this = this;
        this.submitted = true;
        this.UsersModel.voidPayment({
            student_id: this.fee.user_id,
            payment_id: payment_id,
        }).then(function (response) {
            _this.submitted = false;
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.payments[index] = response.payment;
        });
    };
    return FeeDetailController;
}());
FeeDetailController.$inject = ["UsersModel", "FlashService"];
exports.default = FeeDetailController;
